import { TabsPassThroughOptions } from 'primevue/tabs';

export default {
  root: 'w-full ',
} as TabsPassThroughOptions;
